import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
    selector: '[noSpecialChars]',
    host: {
        '(input)': '$event'
    },
    standalone: true
})
export class NoSpecialCharsDirective {
  public lastValue: string;
  @Input() public patternMf: string;
  private regex: any;

  constructor(public ref: ElementRef) {}

  @HostListener('input', ['$event'])
  public onInput($event) {
    const start = $event.target.selectionStart;
    const end = $event.target.selectionEnd;
    $event.target.setSelectionRange(start, end);
    $event.preventDefault();

    if (this.patternMf === 'onlyLetters') {
      this.regex = /[^A-Za-z\s]+/g;
    } else {
      this.regex = /[^A-Za-z0-9\s]+/g;
    }

    if (!this.lastValue || (this.lastValue && $event.target.value.length > 0 && this.lastValue !== $event.target.value)) {
      this.lastValue = this.ref.nativeElement.value = $event.target.value.normalize('NFD')
                                                                        .replace(/[\u0300-\u036f]/g, '')
                                                                        .replace(this.regex, '')
                                                                        .replace(/\s\s+/g, ' ');
      let evt = new Event('input', {'bubbles': true, 'cancelable': false});
      $event.target.dispatchEvent(evt);
    }
  }
}
